<template>
  <div>
    <table class="arith-table">
          <tr>
            <td> &nbsp; </td>
            <td>
              <b-button :pressed="overflow" variant="outline-danger" :disabled="!overflow">Overflow</b-button>  
            </td>
            <td colspan="2" align="right"><b-form-select v-model="size" :options="sizes"/></td>
          </tr>
          <tr>
            <td align="right" class="arith-variables">
              A =
            </td>
            <td class="arith-input">
              <u-input-number v-model="a" decimal signed_binary hexadecimal/>
            </td>
            <td class="arith-equals"> &nbsp; </td>
            <td class="arith-numbers">
              {{convertedA}}
            </td>
          </tr>
          <tr>
            <td align="right" class="arith-variables">
              B =
            </td>
            <td class="arith-input">
              <u-input-number v-model="b" decimal signed_binary hexadecimal/>
            </td>
            <td class="arith-equals arith-bottom"> &plus; </td>
            <td class="arith-numbers arith-bottom">
              {{convertedB}}
            </td>
          </tr>
          <tr>
            <td id="sum" colspan="4" class="arith-numbers">{{sum}}</td>
          </tr>
          <b-popover target="sum" triggers="hover">
            Decimal: #{{this.a.value + this.b.value}}, Hexadecimal: x{{this.convert(this.a.value + this.b.value, 16)}}
          </b-popover>
        </table>
  </div>
</template>

<script>
import {Numbers, fillSignedBinary} from '@/util/numbers'
import UcrDrkInputNumber from '@/components/ucrdrk-input-number'

export default {
  name: 'addition',
  data () {
    return {
      a: {value: 0, base: 2},
      b: {value: 0, base: 2},
      additionBase: 2,
      size: 16,
      sizes: [
        {value: 8, text: '8-bits'},
        {value: 16, text: '16-bits'},
        {value: 32, text: '32-bits'}
      ]
    }
  },
  mixins: [Numbers],
  components: {
    'u-input-number': UcrDrkInputNumber
  },
  computed: {
    sum: function () {
      return fillSignedBinary(this.convert(this.a.value + this.b.value, this.additionBase), this.size)
    },
    convertedA: function () {
      return fillSignedBinary(this.convert(this.a.value, this.additionBase), this.size)
    },
    convertedB: function () {
      return fillSignedBinary(this.convert(this.b.value, this.additionBase), this.size)
    },
    overflow: function () {
      var sign = Math.sign(this.a.value)
      return this.a.valid && this.b.valid && sign === Math.sign(this.b.value) && (sign === 1 ? '0' : '1') !== this.sum[0]
    }
  },
  methods: {
    convert: function (value, base) {
      switch (base) {
        case 2:
          return this.toBinary(value >>> 0)
        case 10:
          return this.toDecimal(value >>> 0)
        case 16:
          return this.toHexadecimal(value)
        default:
          return ''
      }
    }
  }
}
</script>

<style scoped>
.arith-numbers {
  font-family: monospace;
  font-size: x-large;
  text-align: right;
}

.arith-variables {
  width: 50px;
  min-width: 50px;
  max-width: 50px;

}

.arith-input {
  width: 200px;
  min-width: 200px;
  max-width: 200px;
}

.arith-equals {
  width: 40px;
  min-width: 40px;
  max-width: 40px;
  text-align: center;
}

.arith-table {
  width: 425px;
  max-width: 425px;
  min-width: 425px;
}

.arith-bottom {
  border-bottom: 1pt solid black;
}

th, td {
  padding-right: 12px;
  padding-bottom: 7px;
}
</style>


// WEBPACK FOOTER //
// src/components/addition.vue